import { render, staticRenderFns } from "./TableProcess.vue?vue&type=template&id=11039c20&scoped=true"
import script from "./TableProcess.vue?vue&type=script&lang=js"
export * from "./TableProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11039c20",
  null
  
)

export default component.exports